import React from 'react';

import { Widget, WidgetType, isContainer } from '@framework/engine';
import { ColProps } from 'antd';
import { sum } from 'lodash';
import { WidgetColumnWrapper } from './WidgetColumn.styled';

/**
 * Se il parent non ha children o non è un container ritorna 100.
 * Se il parent _non_ è una row, ritorna 100.
 * Altrimenti se è una row calcola la larghezza in base al colspan indicato.
 */
export function getColumnPercentWidth(parent?: Widget) {
  if (!parent || !isContainer(parent) || !parent.children) return 100;
  if (parent.type !== WidgetType.Row) return 100;
  const colNumbers = sum(
    parent.children.map(child => Number(child.layout?.colSpan ?? 1)),
  );
  return 100 / colNumbers;
}

export interface IWidgetColumnProps extends ColProps {
  parent?: Widget;
  widget?: Widget;
  children?: React.ReactNode;
}

/**
 * Elemento Colonna posizionato intorno al Widget che permette il ridimensionamento.
 */
export function WidgetColumn(props: IWidgetColumnProps) {
  const { children, parent, widget } = props;

  const width = (widget?.layout?.colSpan ?? 1) * getColumnPercentWidth(parent);

  return (
    <WidgetColumnWrapper
      width={width}
      // className={clx({
      //   'full-row-container': widget?.type === WidgetType.Row && width === 100
      // })}
    >
      {children}
    </WidgetColumnWrapper>
  );
}
